import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconCheck = props => (
  <SvgIcon {...props} viewBox="0 0 17.59 13.41">
    <path id="path6_fill" fillRule="evenodd" d="m5.59 10.58-4.17-4.17-1.42 1.41l5.59 5.59 12-12-1.41-1.41-10.59 10.58z" />
  </SvgIcon>
);

export default IconCheck;



// WEBPACK FOOTER //
// ./src/components/icons/IconCheck.js